// extracted by mini-css-extract-plugin
export default {"photo":"photo-attachment_photo__9GKpk"};